import { SideBySide } from "../../../../../../../../../../components/side-by-side/side-by-side.component";
import React from "react";
import { FlyerDetailPageFormPositionDateFieldsProps } from "./flyer-detail-page-form-position-date-fields.props";
import {
  ReadonlyField,
  ReadonlyFieldLabel,
} from "../../../../../../../../../../components/form-controls/readonly-field/readonly-field.component";

export const FlyerDetailPageFormPositionDateFields = (
  props: FlyerDetailPageFormPositionDateFieldsProps
) => (
  <SideBySide>
    <ReadonlyField>
      <ReadonlyFieldLabel>Deal Start</ReadonlyFieldLabel>
      {props.startDate}
    </ReadonlyField>
    <ReadonlyField>
      <ReadonlyFieldLabel>Deal End</ReadonlyFieldLabel>
      {props.endDate}
    </ReadonlyField>
  </SideBySide>
);
